module.exports = __webpack_public_path__ + "img/multi-people.ea257ec3.svg";